import Vue from 'vue'
import App from './App.vue'
import router from './router'
import LoadScript from 'vue-plugin-load-script';
import vuetify from '@/plugins/vuetify' // path to vuetify export
import axios from 'axios'

import { firebase } from '@firebase/app'
require('@firebase/auth');

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_MEASUREMENT_ID
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const auth = firebase.auth();

Vue.use(LoadScript)

Vue.config.productionTip = false
Vue.prototype.$http = axios;
Vue.prototype.$auth = auth;

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
